// import React, { useState, useContext, useEffect } from 'react';
// import axios from "axios";
// import { toast } from "react-toastify";
// import { ShopContext } from "../context/ShopContext";
// import { useNavigate } from "react-router-dom";
// import Toast from './Tost';
// const SignUp = () => {

//     const { token, setToken, backendUrl,addToCart } = useContext(ShopContext);
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [mobilenumber, setMobileNumber] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [gender, setGender] = useState("");
//   const [toastMessage, setToastMessage] = useState(null);

//   const handleSignUp = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(`${backendUrl}/api/user/register`, {
//         name,
//         email,
//         mobilenumber,
//         password,
//         gender,
//       });
//       if (response.data.success) {
//         setToken(response.data.token);
//         localStorage.setItem("token", response.data.token);
//         navigate("/");
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//    useEffect(() => {
//       if (token) { // Check if user is logged in
//         const pendingCartItem = localStorage.getItem("pendingCartItem");
        
//         if (pendingCartItem) {
//           const { itemId, size, color } = JSON.parse(pendingCartItem);
    
//           addToCart(itemId, size, color);
//           setToastMessage("Item added to cart after login! ✅");
    
//           // Remove the stored item after adding to cart
//           localStorage.removeItem("pendingCartItem");
//         }
    
//         navigate('/');  // Navigate after processing the cart item
//       }
//     }, [token]);  // Runs when token is set after login

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left side image */}
//       <div
//         className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg"
//         style={{
//           backgroundImage:
//             "url(https://res.cloudinary.com/djqeoutoy/image/upload/v1738567988/gipwf9egb7o9kvf1bwli.jpg)",
//         }}
//       ></div>

//       {/* Right side form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">Sign Up</h2>

//           {/* Toggle buttons for Login/Signup */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               onClick={() => navigate("/login")}
//               className="w-24 py-2 rounded-l-md border bg-gray-200 text-black"
//             >
//               Login
//             </button>
//             <button
//               className="w-24 py-2 rounded-r-md border bg-[#FF4902] text-white"
//               disabled
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form content */}
//           <form onSubmit={handleSignUp} className="space-y-4">
//             <input
//               onChange={(e) => setName(e.target.value)}
//               value={name}
//               type="text"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Name"
//               required
//             />
//             <input
//               onChange={(e) => setMobileNumber(e.target.value)}
//               value={mobilenumber}
//               type="number"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Mobile Number"
//               required
//             />
//             <input
//               onChange={(e) => setEmail(e.target.value)}
//               value={email}
//               type="email"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />

//             {/* Gender Field */}
//             <div>
//               <p className="text-sm font-semibold mb-2">Gender:</p>
//               <div className="flex justify-between space-x-4"> {/* Added spacing */}
//                 {["Male", "Female", "Other"].map((g) => (
//                   <button
//                     key={g}
//                     type="button"
//                     className={`w-1/3 py-1 px-3 text-sm rounded border ${
//                       gender === g
//                         ? "border-[#FF4902] text-[#FF4902]"
//                         : "border-gray-300 text-black"
//                     }`}
//                     onClick={() => setGender(g)}
//                   >
//                     {g}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <input
//               onChange={(e) => setPassword(e.target.value)}
//               value={password}
//               type="password"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               Sign Up
//             </button>

//             {/* Divider with OR */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             {/* Social login buttons *        */}
            
//             <div className="flex mb-4 space-x-2">
//               <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white mb-2 text-sm"
//               >
//                 Google
//               </button>
//               <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white mb-2 text-sm"
//               >
//                 Facebook
//               </button>
//             </div>

//             {/* Terms and conditions */}
//             <div className="text-center text-sm">
//               <p>
//                 By creating an account or logging in, you agree with Mammoth
//                 Streetwear®’s{" "}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/terms")}
//                 >
//                   Terms and Conditions
//                 </span>{" "}
//                 and{" "}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/privacy-policy")}
//                 >
//                   Privacy Policy
//                 </span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;

// import React, { useState, useContext, useEffect } from 'react';
// import axios from "axios";
// import { toast } from "react-toastify";
// import { ShopContext } from "../context/ShopContext";
// import { useNavigate } from "react-router-dom";
// // import { useGoogleLogin } from '@react-oauth/google';

// const SignUp = () => {
//   const { token, setToken, backendUrl, addToCart } = useContext(ShopContext);
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [mobilenumber, setMobileNumber] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [gender, setGender] = useState("");

//   const handleSignUp = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(`${backendUrl}/api/user/register`, {
//         name,
//         email,
//         mobilenumber,
//         password,
//         gender,
//       });
//       if (response.data.success) {
//         setToken(response.data.token);
//         localStorage.setItem("token", response.data.token);
//         navigate("/");
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   // ✅ Google OAuth callback
//   // const responseGoogle = async (authResult) => {
//   //   try {
//   //     if (authResult["code"]) {
//   //       const result = await axios.get(
//   //         `${backendUrl}/auth/google/callback?code=${authResult.code}`
//   //       );
//   //       const { token } = result.data.user;
//   //       setToken(token);
//   //       localStorage.setItem("token", token);
//   //       navigate("/");
//   //     } else {
//   //       throw new Error("No auth code received");
//   //     }
//   //   } catch (e) {
//   //     toast.error("Error while Google Sign Up...");
//   //     console.error(e);
//   //   }
//   // };

// const handleGoogleLogin = () => {
//   // open backend Google login route directly
//   window.open(`${backendUrl}/api/user/auth/google`, "_self");
// };

//   // ✅ Initialize Google Login hook
//   // const googleLogin = useGoogleLogin({
//   //   onSuccess: responseGoogle,
//   //   onError: responseGoogle,
//   //   flow: "auth-code",
//   // });

// useEffect(() => {
//   const urlParams = new URLSearchParams(window.location.search);
//   const tokenFromUrl = urlParams.get("token");
//   if (tokenFromUrl) {
//     setToken(tokenFromUrl);
//     localStorage.setItem("token", tokenFromUrl);
//     navigate("/");
//   }
// }, []);

//   useEffect(() => {
//     if (token) {
//       const pendingCartItem = localStorage.getItem("pendingCartItem");
//       if (pendingCartItem) {
//         const { itemId, size, color } = JSON.parse(pendingCartItem);
//         addToCart(itemId, size, color);
//         localStorage.removeItem("pendingCartItem");
//         toast.success("Item added to cart after login ✅");
//       }
//       navigate("/");
//     }
//   }, [token]);

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left side image */}
//       <div
//         className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg"
//         style={{
//           backgroundImage:
//             "url(https://res.cloudinary.com/djqeoutoy/image/upload/v1738567988/gipwf9egb7o9kvf1bwli.jpg)",
//         }}
//       ></div>

//       {/* Right side form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">Sign Up</h2>

//           {/* Toggle buttons for Login/Signup */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               onClick={() => navigate("/login")}
//               className="w-24 py-2 rounded-l-md border bg-gray-200 text-black"
//             >
//               Login
//             </button>
//             <button
//               className="w-24 py-2 rounded-r-md border bg-[#FF4902] text-white"
//               disabled
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form content */}
//           <form onSubmit={handleSignUp} className="space-y-4">
//             <input
//               onChange={(e) => setName(e.target.value)}
//               value={name}
//               type="text"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Name"
//               required
//             />
//             <input
//               onChange={(e) => setMobileNumber(e.target.value)}
//               value={mobilenumber}
//               type="number"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Mobile Number"
//               required
//             />
//             <input
//               onChange={(e) => setEmail(e.target.value)}
//               value={email}
//               type="email"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />

//             {/* Gender Field */}
//             <div>
//               <p className="text-sm font-semibold mb-2">Gender:</p>
//               <div className="flex justify-between space-x-4">
//                 {["Male", "Female", "Other"].map((g) => (
//                   <button
//                     key={g}
//                     type="button"
//                     className={`w-1/3 py-1 px-3 text-sm rounded border ${
//                       gender === g
//                         ? "border-[#FF4902] text-[#FF4902]"
//                         : "border-gray-300 text-black"
//                     }`}
//                     onClick={() => setGender(g)}
//                   >
//                     {g}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <input
//               onChange={(e) => setPassword(e.target.value)}
//               value={password}
//               type="password"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               Sign Up
//             </button>

//             {/* Divider with OR */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             {/* Social login buttons */}
//             <div className="flex mb-4 space-x-2">
//               <button
//                 onClick={handleGoogleLogin}
//                 type="button"
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white text-sm"
//               >
//                 Continue with Google
//               </button>
//               <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white text-sm cursor-not-allowed opacity-50"
//                 disabled
//               >
//                 Facebook
//               </button>
//             </div>

//             {/* Terms and conditions */}
//             <div className="text-center text-sm">
//               <p>
//                 By creating an account or logging in, you agree with Mammoth
//                 Streetwear®’s{" "}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/terms")}
//                 >
//                   Terms and Conditions
//                 </span>{" "}
//                 and{" "}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/privacy-policy")}
//                 >
//                   Privacy Policy
//                 </span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;


// import React, { useState, useContext, useEffect } from 'react';
// import axios from "axios";
// import { toast } from "react-toastify";
// import { ShopContext } from "../context/ShopContext";
// import { useNavigate } from "react-router-dom";
// import { FcGoogle } from "react-icons/fc";
// const SignUp = () => {
//   const { token, setToken, backendUrl, addToCart } = useContext(ShopContext);
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [mobilenumber, setMobileNumber] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [gender, setGender] = useState("");

//   // ✅ Handle normal signup
//   const handleSignUp = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(`${backendUrl}/api/user/register`, {
//         name,
//         email,
//         mobilenumber: mobilenumber || undefined, // optional
//         password,
//         gender,
//       });

//       if (response.data.success) {
//         handleToken(response.data.token);
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   // ✅ Handle Google login redirect
//   const handleGoogleLogin = () => {
//     window.open(`${backendUrl}/api/user/auth/google`, "_self");
//   };

//   // ✅ Centralized token handling
//   const handleToken = (newToken) => {
//     setToken(newToken);
//     localStorage.setItem("token", newToken);

//     const pendingCartItem = localStorage.getItem("pendingCartItem");
//     if (pendingCartItem) {
//       const { itemId, size, color } = JSON.parse(pendingCartItem);
//       addToCart(itemId, size, color);
//       localStorage.removeItem("pendingCartItem");
//       toast.success("Item added to cart after login ✅");
//     }

//     navigate("/"); // single redirect
//   };

  
//   // ✅ Check if URL has token (from Google OAuth callback)
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const tokenFromUrl = urlParams.get("token");
//     if (tokenFromUrl) {
//       handleToken(tokenFromUrl);
//     }
//   }, []);

//   // ✅ Redirect if already logged in
//   useEffect(() => {
//     if (token) handleToken(token);
//   }, [token]);

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left image */}
//       <div
//         className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg"
//         style={{
//           backgroundImage:
//             "url(https://res.cloudinary.com/djqeoutoy/image/upload/v1738567988/gipwf9egb7o9kvf1bwli.jpg)",
//         }}
//       ></div>

//       {/* Right form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">Sign Up</h2>

//           {/* Toggle Login/Signup */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               onClick={() => navigate("/login")}
//               className="w-24 py-2 rounded-l-md border bg-gray-200 text-black"
//             >
//               Login
//             </button>
//             <button
//               className="w-24 py-2 rounded-r-md border bg-[#FF4902] text-white"
//               disabled
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSignUp} className="space-y-4">
//             <input
//               onChange={(e) => setName(e.target.value)}
//               value={name}
//               type="text"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Name"
//               required
//             />
//             <input
//               onChange={(e) => setMobileNumber(e.target.value)}
//               value={mobilenumber}
//               type="number"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Mobile Number (Optional)"
//             />
//             <input
//               onChange={(e) => setEmail(e.target.value)}
//               value={email}
//               type="email"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />

//             {/* Gender buttons */}
//             <div>
//               <p className="text-sm font-semibold mb-2">Gender:</p>
//               <div className="flex justify-between space-x-4">
//                 {["Male", "Female", "Other"].map((g) => (
//                   <button
//                     key={g}
//                     type="button"
//                     className={`w-1/3 py-1 px-3 text-sm rounded border ${
//                       gender === g
//                         ? "border-[#FF4902] text-[#FF4902]"
//                         : "border-gray-300 text-black"
//                     }`}
//                     onClick={() => setGender(g)}
//                   >
//                     {g}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <input
//               onChange={(e) => setPassword(e.target.value)}
//               value={password}
//               type="password"
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               Sign Up
//             </button>

//             {/* OR Divider */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             {/* Social login */}
//             {/* Social login */}
// {/* Social login */}
// <div className="flex mb-4">
//   <button
//     onClick={handleGoogleLogin}
//     type="button"
//     className="w-full py-3 border border-black rounded flex items-center justify-center space-x-2 text-sm bg-white text-[#FF4902]"
//   >
//     <FcGoogle className="w-5 h-5" />
//     <span>Continue with Google</span>
//   </button>
// </div>

//             {/* Terms */}
//             <div className="text-center text-sm">
//               <p>
//                 By creating an account or logging in, you agree with Mammoth
//                 Streetwear®’s{" "}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/terms")}
//                 >
//                   Terms and Conditions
//                 </span>{" "}
//                 and{" "}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/privacy-policy")}
//                 >
//                   Privacy Policy
//                 </span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;

import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { ShopContext } from "../context/ShopContext";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";

const SignUp = () => {
    useEffect(() => {
        const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
        axios.post(`${backendUrl}/api/analytics/visit`, { page: "Sign Up" })
          .then(res => console.log(" visit recorded:", res.data))
          .catch(err => console.error("Analytics error:", err));
      }, []);
  const { token, setToken, backendUrl, addToCart } = useContext(ShopContext);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [mobilenumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [gender, setGender] = useState("");

  // ✅ Handle normal signup
  const handleSignUp = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${backendUrl}/api/user/register`, {
        name,
        email,
        mobilenumber: mobilenumber || undefined, // optional
        password,
        gender,
      });

      if (response.data.success) {
        handleToken(response.data.token);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // ✅ Handle Google login redirect
  const handleGoogleLogin = () => {
    window.open(`${backendUrl}/api/user/auth/google`, "_self");
  };

  // ✅ Centralized token handling
  const handleToken = (newToken) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
    navigate("/"); // redirect after login/signup
  };

  // ✅ Process pending cart items once token is set
  useEffect(() => {
    if (token) {
      const pendingCartItem = localStorage.getItem("pendingCartItem");
      if (pendingCartItem) {
        const { itemId, size, color } = JSON.parse(pendingCartItem);
        addToCart(itemId, size, color);
        localStorage.removeItem("pendingCartItem");
        toast.success("Item added to cart after login ✅");
      }
    }
  }, [token, addToCart]);

  // ✅ Check if URL has token (from Google OAuth callback)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get("token");
    if (tokenFromUrl) {
      handleToken(tokenFromUrl);
    }
  }, []);

  return (
    <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
      {/* Left image */}
      <div
        className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg"
        style={{
          backgroundImage:
            "url(https://res.cloudinary.com/djqeoutoy/image/upload/v1738567988/gipwf9egb7o9kvf1bwli.jpg)",
        }}
      ></div>

      {/* Right form */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg">
        <div className="w-full max-w-md">
          <h2 className="text-2xl font-bold text-center mb-6">Sign Up</h2>

          {/* Toggle Login/Signup */}
          <div className="flex justify-left mb-6 w-full">
            <button
              onClick={() => navigate("/login")}
              className="w-24 py-2 rounded-l-md border bg-gray-200 text-black"
            >
              Login
            </button>
            <button
              className="w-24 py-2 rounded-r-md border bg-[#FF4902] text-white"
              disabled
            >
              Sign Up
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSignUp} className="space-y-4">
            <input
              onChange={(e) => setName(e.target.value)}
              value={name}
              type="text"
              className="w-full p-3 border border-black rounded text-sm"
              placeholder="Name"
              required
            />
            <input
              onChange={(e) => setMobileNumber(e.target.value)}
              value={mobilenumber}
              type="number"
              className="w-full p-3 border border-black rounded text-sm"
              placeholder="Mobile Number (Optional)"
            />
            <input
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              type="email"
              className="w-full p-3 border border-black rounded text-sm"
              placeholder="Email"
              required
            />

            {/* Gender buttons */}
            <div>
              <p className="text-sm font-semibold mb-2">Gender:</p>
              <div className="flex justify-between space-x-4">
                {["Male", "Female", "Other"].map((g) => (
                  <button
                    key={g}
                    type="button"
                    className={`w-1/3 py-1 px-3 text-sm rounded border ${
                      gender === g
                        ? "border-[#FF4902] text-[#FF4902]"
                        : "border-gray-300 text-black"
                    }`}
                    onClick={() => setGender(g)}
                  >
                    {g}
                  </button>
                ))}
              </div>
            </div>

            <input
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              type="password"
              className="w-full p-3 border border-black rounded text-sm"
              placeholder="Password"
              required
            />

            <button
              type="submit"
              className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
            >
              Sign Up
            </button>

            {/* OR Divider */}
            <div className="flex items-center mb-4">
              <hr className="w-full border-gray-300" />
              <span className="mx-4 text-gray-500 text-sm">Or</span>
              <hr className="w-full border-gray-300" />
            </div>

            {/* Social login */}
            <div className="flex mb-4">
              <button
                onClick={handleGoogleLogin}
                type="button"
                className="w-full py-3 border border-black rounded flex items-center justify-center space-x-2 text-sm bg-white text-[#FF4902]"
              >
                <FcGoogle className="w-5 h-5" />
                <span>Continue with Google</span>
              </button>
            </div>

            {/* Terms */}
            <div className="text-center text-sm">
              <p>
                By creating an account or logging in, you agree with Mammoth
                Streetwear®’s{" "}
                <span
                  className="font-bold cursor-pointer"
                  onClick={() => navigate("/terms")}
                >
                  Terms and Conditions
                </span>{" "}
                and{" "}
                <span
                  className="font-bold cursor-pointer"
                  onClick={() => navigate("/privacy-policy")}
                >
                  Privacy Policy
                </span>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
